import { registerEnum } from '@cbbt/lib-interface';
var EmploymentStatus;
(function (EmploymentStatus) {
    EmploymentStatus["EMPLOYED_FULL_OR_PART_TIME"] = "EMPLOYED_FULL_OR_PART_TIME";
    EmploymentStatus["EMPLOYED_FULL_TIME_ABOVE_16_HOURS"] = "EMPLOYED_FULL_TIME_ABOVE_16_HOURS";
    EmploymentStatus["EMPLOYED_PART_TIME_BELOW_16_HOURS"] = "EMPLOYED_PART_TIME_BELOW_16_HOURS";
    EmploymentStatus["EMPLOYER"] = "EMPLOYER";
    EmploymentStatus["FULL_TIME_EDUCATION_STUDENT"] = "FULL_TIME_EDUCATION_STUDENT";
    EmploymentStatus["HOUSEWIFE_HOMEMAKER"] = "HOUSEWIFE_HOMEMAKER";
    EmploymentStatus["LBG_MEMBER_OF_STAFF"] = "LBG_MEMBER_OF_STAFF";
    EmploymentStatus["NO_RESPONSE"] = "NO_RESPONSE";
    EmploymentStatus["NOT_EMPLOYED"] = "NOT_EMPLOYED";
    EmploymentStatus["NOT_WORKING_DISABILITY_BENEFIT"] = "NOT_WORKING_DISABILITY_BENEFIT";
    EmploymentStatus["NOT_WORKING_INDEPENDENT_MEANS"] = "NOT_WORKING_INDEPENDENT_MEANS";
    EmploymentStatus["NOT_WORKING_NO_INCOME"] = "NOT_WORKING_NO_INCOME";
    EmploymentStatus["NOT_WORKING_OTHER_BENEFIT"] = "NOT_WORKING_OTHER_BENEFIT";
    EmploymentStatus["NOT_WORKING_UNEMPLOYED"] = "NOT_WORKING_UNEMPLOYED";
    EmploymentStatus["OTHER"] = "OTHER";
    EmploymentStatus["OTHER_FROM_CBS_OR_BOS"] = "OTHER_FROM_CBS_OR_BOS";
    EmploymentStatus["RETIRED"] = "RETIRED";
    EmploymentStatus["SEEKING_WORK"] = "SEEKING_WORK";
    EmploymentStatus["SELF_EMPLOYED"] = "SELF_EMPLOYED";
    EmploymentStatus["STUDENT_GAP_YEAR"] = "STUDENT_GAP_YEAR";
    EmploymentStatus["TSB_OTHER_TSB_STAFF"] = "TSB_OTHER_TSB_STAFF";
    EmploymentStatus["TSB_TSB_BANK_STAFF"] = "TSB_TSB_BANK_STAFF";
    EmploymentStatus["UNAVAILABLE_FOR_WORK"] = "UNAVAILABLE_FOR_WORK";
    EmploymentStatus["UNEMPLOYED"] = "UNEMPLOYED";
    EmploymentStatus["UNKNOWN"] = "UNKNOWN";
})(EmploymentStatus || (EmploymentStatus = {}));
registerEnum(EmploymentStatus, 'EmploymentStatus');
export { EmploymentStatus };
//# sourceMappingURL=EmploymentStatus.js.map